<template lang="pug">
y-dialog(v-model="showModal" :fullscreen="$vuetify.breakpoint.xsOnly" max-width="600" persistent scrollable content-class="round-3xl")
  v-card
    v-card-title.px-4.py-3
      v-row(no-gutters align="center")
        v-col(cols="10" offset="1")
          div.text-xl.font-bold.neutral700--text.text-center {{ $t('invite_via') }} {{ sendingMethod }}
        v-col(cols="1" align="right")
          v-btn.ml-n3(text icon @click="closeDialog")
            v-icon(color="neutral700" :size="24") mdi-close
    v-divider.mb-4
    credit-alert.mx-8(v-if="sendingMethod === 'sms'" :credit="creditBalance" :title="$t('reload_now_to_send_message')" :showTitle="true" titleFont="heading-6" descFont="text-xs" buttonSize="button-sm")
    v-card-text.px-8.pb-8
      //- Preview email body
      template(v-if="sendingMethod === 'email'")
        div.heading-6.basic700--text.mt-4.mb-8 {{ $t('email_preview') }}
        .d-flex.justify-center
          preview-iphone
            //- Email navbar
            preview-iphone-email-navbar.my-4
            .ml-2.my-4
              //- Subject line
              .h6.text-left.mb-2(v-if="emailSubject") {{ emailSubject }}
              //- Sending info
              .d-flex.align-center.justify-space-between.my-4
                .d-flex
                  v-avatar(size="30" color="zooPurple")
                    span.white--text Y
                  .ml-4
                    .d-flex.mb-1
                      .text-xs.font-semibold.mr-1 Yezza Team
                      .text-xxs 5 days ago
                    .d-flex.align-center
                      .text-xs.mr-1 to me
                      v-icon(size="13") mdi-chevron-down
                .d-flex
                  v-icon.mr-3(size="15" color="basic700") $yzi-ios-safari-reply-arrow
                  v-icon(size="15" color="basic700") mdi-dots-vertical
              //- Body
              v-skeleton-loader.mb-4(boilerplate type="heading")
              v-skeleton-loader(boilerplate type="sentences")
      //- Preview whatsapp & sms message
      template(v-else)
        div.heading-6.basic700--text.mt-4 {{ $t('message_preview') }}
        v-card.message-preview-border.pa-4.mt-4.round-xl(outlined)
          div.text-md.font-normal.basic600--text(style="white-space: pre-wrap;" v-html="previewMessage")
        
      div.text-md.font-normal.neutral700--text.mt-6 {{ $t('you_cant_undo_send_message') }}
    v-divider
    v-card-actions.pa-4
      v-btn(color="white" text @click="closeDialog")
        .text-md.font-semibold.primary700--text.underline.capitalize {{ $t("cancel") }}
      v-spacer
      v-btn.button-md(color="neutral700" depressed dark :loading="isLoading" @click="$emit('send')")
        .text-md {{ $t('send') }}
</template>

<script>
import { mapGetters } from 'vuex'
import CreditAlert from '@/components/yezzabook/dialogs/CreditAlert.vue'
import PreviewIphone from '@/components/review/preview/PreviewIphone.vue'
import PreviewIphoneEmailNavbar from '@/components/review/preview/PreviewIphoneEmailNavbar.vue'

export default {
  name: 'SendReviewInviteDialog',
  components: {
    CreditAlert,
    PreviewIphone,
    PreviewIphoneEmailNavbar
  },
  props: {
    open: {
      type: Boolean,
    },
    isLoading: {
      type: Boolean
    },
    previewMessage: {
      type: String,
      default: ''
    },
    emailSubject: {
      type: String,
      default: ''
    },
    sendingMethod: {
      type: String,
      required: true,
      validation(value) {
        return ['sms', 'WhatsApp', 'email'].includes(value)
      }
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany'
    }),
    showModal: {
      get () {
        return this.open
      },
      set (val) {
        this.$emit('update:open', val)
      }
    },
    creditBalance() {
      return this.company.prepaid_credits
    },
  },
  methods: {
    closeDialog() {
      this.$emit('close')
      this.showModal = false
    }
  },
}
</script>

<style scoped>
.message-preview-border {
  border: var(--v-basic500) solid 1px;
}
</style>